import {createSelector} from 'reselect';
import {getGuestErrorObject} from '../utils/guests';
import {getTranslations, getTripData} from './store';
import {getSleeps, getPetsAllowed, getMaxAdults} from './listing';

const getGuestsError = createSelector(
    [getSleeps, getPetsAllowed, getTranslations, getTripData, getMaxAdults],
    (sleeps, petsAllowed, translations, tripData, maxAdults) => {
        const {adults, children, hasPets} = tripData;

        return getGuestErrorObject({
            adults,
            children,
            hasPets,
            maxAdults,
            petsAllowed,
            sleeps,
            translations
        });
    }
);

export {getGuestsError};
